import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { PaginatedColocApiConnectedDropDown } from '@/features/shared/feature-paginated-coloc-api-connected-dropdown';
import { House } from '@/types/admin';
import { useGetHousesInfinite } from '@/features/shared/hooks/use-get-houses-infinite';
import { useVacancyMaintenanceFiltersContext } from '../../../../hooks/use-vacancy-maintenance-filters';

const VacancyHouseSelectionDropDown = () => {
  const { selectedVacancyHouse, setSelectedVacancyHouse, housesQuery, setHousesQuery } =
    useVacancyMaintenanceFiltersContext();
  const { t } = useTranslation();

  return (
    <PaginatedColocApiConnectedDropDown<House>
      placeholder={t('js.features.admin.stats.dashboard.vacancy.house_selection.placeholder')}
      className="z-50 w-[200px]"
      showLabel
      value={selectedVacancyHouse}
      onChange={setSelectedVacancyHouse}
      {...(selectedVacancyHouse && {
        displayValue: selectedVacancyHouse.name,
      })}
      onTextInputChange={(event) => setHousesQuery(event.target.value)}
      dataSource={
        useGetHousesInfinite({
          searchQuery: housesQuery,
        })!
      }
      itemRenderer={(itemProps, ref) => (
        <DropDown.DropDownOptionDefaultContent
          ref={ref}
          className="font-['sofia-pro'] text-sm font-normal leading-[21px] text-[#212529]"
        >
          {itemProps.name}
        </DropDown.DropDownOptionDefaultContent>
      )}
    />
  );
};

export default VacancyHouseSelectionDropDown;
